
import { db } from '@/main'
import { doc, updateDoc } from "firebase/firestore";
import { formatDistance } from "date-fns";
import LineChart from "@/components/lineChart"
import { orderBy } from "lodash";

export default {
  name: "organisation",
  components: {
    LineChart,
  },
  props: [],
  data() {
    return {
      view: {
        bookingModal: false,
        orgError: null,
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters.userData;
    },
    org() {
      return this.$store.getters.activeOrg;
    },
    orgSecure() {
      return this.$store.getters.activeOrgSecure;
    },
    storeResources () {
      return this.$store.getters.docFiles(null, "resources")
    },
    groups() {
      return this.$store.state.groups.docs;
    },
    orgLink() {
      return `${window.location.origin}/app/${this.org.name}`;
    },
    orgAccess () {
      return this.$store.getters.activeOrgAccess;
    },
    onboardingDone() {
      return (
        this.org.onboarding.invitedGuests &&
        this.org.onboarding.createdResources &&
        this.org.onboarding.customised &&
        this.org.onboarding.sharedLink
      );
    },
    dynamicLogs() {
      return this.$store.state.logs.boundFile &&
        this.$store.state.logs.boundFile.events
        ? orderBy(this.$store.state.logs.boundFile.events ,"at", "desc").slice(0, 10)
        : [];
    },
    staticLogs() {
      return this.$store.state.logs.staticLogs.slice(
        0,
        10 - (this.dynamicLogs ? this.dynamicLogs.length :0)
      );
    }
  },
  mounted: async function () {
    // check for query params to launch onboarding
    console.log('this.$route.query:', this.$route.query);

    if (this.$route.query.hasOwnProperty("onboard")) {
      console.log("onboard the user");
      this.onboarding = true;
    }
    
  },
  methods: {
    dismissOnboarding() {
      console.log("dismissing onboarding");
      this.org.onboarding.dismissed = true;
      this.onboardingUpdate();
    },
    async onboardingUpdate() {
      console.log("onboarding update:", this.org.onboarding);

      try {
        await updateDoc(doc(db, "orgs", this.org.id), {
          onboarding: this.org.onboarding,
        });

        console.log("org onboarding updated");
      } catch (error) {
        console.log("err saving org:", error);
        this.$toast.error(`Something went wrong saving`);
      }
    },
    selectTextArea: function (event) {
      event.target.select();

      let copyText = this.$refs.orgLinkTextarea;

      /* Select the text field */
      copyText.setSelectionRange(0, 99999); /* For mobile devices */

      /* Copy the text inside the text field */
      document.execCommand("copy");

      /* Alert the copied text */
      this.$toast.success("Copied to clipboard!");
    },
    formatDateTime(time) {
      // return format(new Date(time), "hh:mm:ss - dd MMM yyyy");
      return formatDistance(new Date(time), new Date(), { addSuffix: true });
    },
    getUser(id) {
      if (id == this.user.id) return this.$t("audit-log-you");
      if (id.includes("@")) {
        // assume it's an email address, return it
        return id;
      }
      return this.$t("audit-log-teammate");
    },
  },
};
